import { Dispatch, SetStateAction } from "react";

import { UserRoles } from "../../lib/role-based-access-control";
import { AccountStatus, AccountType, LinkedRegistry } from "../../types/generated/graphql";

export type AppUserAccountInfo = {
  id: string;
  tenantId: string;
  firstName?: string | null;
  lastName?: string | null;
  email?: string | null;
  roles?: UserRoles[];
  status?: AccountStatus;
  linkedRegistries?: LinkedRegistry[];
  accountType?: AccountType | null;
  loaded: boolean;
};

export type AppUserSelections = {
  registry?: LinkedRegistry | null;
};

export type AppContextType = {
  userAccountInfo: AppUserAccountInfo | null;
  setUserAccountInfo: Dispatch<SetStateAction<AppUserAccountInfo | null>>;
  userSelections: AppUserSelections | null;
  setUserSelections: Dispatch<SetStateAction<AppUserSelections | null>>;
};

export const KEY_ACTIVE_REGISTRY_ID = "active_registry_id";
